import { render, staticRenderFns } from "./ConfirmChip.vue?vue&type=template&id=aa9889f8&scoped=true"
import script from "./ConfirmChip.vue?vue&type=script&lang=js"
export * from "./ConfirmChip.vue?vue&type=script&lang=js"
import style0 from "./ConfirmChip.vue?vue&type=style&index=0&id=aa9889f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9889f8",
  null
  
)

export default component.exports